import styled from "styled-components";
import { flexCenterAlignItemsMixin, flexRowContainerMixin } from "../../../../themes/architecture/css-helpers/flex";

export const MobileMenuHeaderDefaultBox = styled.div`
    ${flexRowContainerMixin}
    ${flexCenterAlignItemsMixin}
    padding: 0.5rem 1.5rem;
    padding-top: calc(env(safe-area-inset-top) + 0.5rem);
    background: ${({theme}) => theme.colors.backgroundDark};
`;
